export const allClientNavbarContainer = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginBottom: "1.5rem",
  borderBottom: "1px solid rgba(112, 112, 112, 0.21)",
  flexWrap: "wrap",
  paddingBottom: "4px",
  margin: "5px",

  "& .sort": {
    fontSize: "12px",
  },

  "& hr": {
    border: "1px solid #bdb7b7",
    width: "16px",
    rotate: "90deg",
  },
  width:'100%'
};
